import { ReownAppKitNetworkConfig } from '../models';

export const ETHEREUM_NETWORK: ReownAppKitNetworkConfig = {
  chainId: 1,
  chainIdHex: '0x1',
  name: 'Ethereum',
};

export const BASE_NETWORK: ReownAppKitNetworkConfig = {
  chainId: 8453,
  chainIdHex: '0x2105',
  name: 'Base',
};

export const BASE_SEPOLIA_NETWORK: ReownAppKitNetworkConfig = {
  chainId: 84532,
  chainIdHex: '0x14a34',
  name: 'Base Sepolia',
};
